const trimEnv = (value) => (typeof value === 'string' ? value.trim() : '');

const inferBrowserHost = () => {
  if (typeof window === 'undefined') return 'localhost';
  return window.location.hostname || 'localhost';
};

const safeUrl = (value) => {
  try {
    return new URL(value);
  } catch {
    return null;
  }
};

const parseSipRegistrarHost = (value) => {
  const trimmed = trimEnv(value).replace(/^sip:/i, '');
  if (!trimmed) return '';
  const [host] = trimmed.split(':');
  return host || '';
};

const parseSipRegistrarPort = (value) => {
  const trimmed = trimEnv(value).replace(/^sip:/i, '');
  if (!trimmed) return '';
  const [, port] = trimmed.split(':');
  return port || '';
};

const inferredHost =
  trimEnv(process.env.REACT_APP_SIP_DOMAIN) ||
  parseSipRegistrarHost(process.env.REACT_APP_SIP_REGISTRAR) ||
  safeUrl(trimEnv(process.env.REACT_APP_SIP_WS_URL))?.hostname ||
  inferBrowserHost();

const inferredWsProtocol =
  typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss' : 'ws';
const inferredWsPort =
  safeUrl(trimEnv(process.env.REACT_APP_SIP_WS_URL))?.port ||
  (inferredWsProtocol === 'wss' ? '8089' : '8088');
const inferredRegistrarPort =
  parseSipRegistrarPort(process.env.REACT_APP_SIP_REGISTRAR) ||
  '5060';

export const SIP_DOMAIN = inferredHost;
export const SIP_WS_URL = (
  trimEnv(process.env.REACT_APP_SIP_WS_URL) ||
  `${inferredWsProtocol}://${inferredHost}:${inferredWsPort}/ws`
).replace(/\/$/, '');
export const SIP_REGISTRAR = trimEnv(process.env.REACT_APP_SIP_REGISTRAR) || `sip:${inferredHost}:${inferredRegistrarPort}`;
export const SIP_SERVER_LABEL = `${SIP_DOMAIN}:${inferredRegistrarPort}`;

// ==========================================================================
// WebRTC ICE (STUN/TURN) servers — configured HERE in code (no .env needed).
// ==========================================================================
// STUN: client ko apna public (reflexive) address deta hai taake Asterisk ke
// public media address (external_media_address) se direct media ban sake.
// Media STUN se nahi guzarta, sirf address discovery. Foran active.
const STUN_URLS = [
  'stun:stun.l.google.com:19302',
  'stun:stun1.l.google.com:19302'
];

// TURN: SIRF tab enable karein jab coturn server chal raha ho AUR reachable ho.
// Unreachable TURN ICE gathering ko slow/hang kar deta hai (call "checking" par
// atakti hai). Is liye default OFF hai. coturn chalne ke baad neeche
// TURN_ENABLED = true kar dein — values TURN_SETUP.md / turnserver.conf se match.
const TURN_ENABLED = true;
// UDP is the normal TURN media path. Keep connection-oriented TURN opt-in:
// Chromium can reject its TCP socket on multi-interface machines with ICE 701.
const TURN_TCP_ENABLED = trimEnv(process.env.REACT_APP_TURN_TCP_ENABLED).toLowerCase() === 'true';
// IP use kar rahe hain (hostname nahi) taake browser mein "TURN host lookup"
// (DNS error 701) na aaye. turns:5349 (TLS) IP ke sath cert validate nahi karta,
// is liye filhaal sirf turn: udp/tcp — jo NAT traversal ke liye kaafi hai.
const TURN_IP = '125.209.87.30';
const TURN_USERNAME = 'webrtc';
const TURN_PASSWORD = '90acf8436ab703fb3ed5dca8664033862539c760';
const TURN_URLS = (TURN_ENABLED && TURN_IP)
  ? [
      `turn:${TURN_IP}:3478?transport=udp`,
      ...(TURN_TCP_ENABLED ? [`turn:${TURN_IP}:3478?transport=tcp`] : [])
    ]
  : [];

export const getIceServers = () => {
  const servers = [];

  if (STUN_URLS.length) {
    servers.push({ urls: STUN_URLS });
  }

  if (TURN_URLS.length && TURN_USERNAME && TURN_PASSWORD) {
    servers.push({
      urls: TURN_URLS,
      username: TURN_USERNAME,
      credential: TURN_PASSWORD
    });
  }

  return servers;
};
